<template>
  <div>
    <v-btn @click="addMarketDialog = true" dark elevation="0" color="info">
      <v-icon left>mdi-plus-box-multiple-outline</v-icon>
      {{ $t('area.add_market_area') }}</v-btn
    >
    <v-dialog v-model="areaDialog" max-width="350">
      <v-card>
        <v-card-title
          ><v-icon left>mdi-plus-box-multiple-outline</v-icon
          >{{ $t('area.add_market_area') }}</v-card-title
        >
        <v-card-text>
          <h2>{{ getMarketName }}</h2>
          <p class="mb-1">{{ $t('area.market_area_name_and_area_number') }}</p>
          <v-text-field
            flat
            solo
            background-color="grey lighten-3"
            name="name"
            :label="$t('input_data')"
            :placeholder="$t('input_data')"
            v-model="form.name"
          ></v-text-field>
          <p class="mb-1">{{ $t('size') }} ({{ $t('square_meter') }})</p>
          <v-currency-field
            flat
            solo
            background-color="grey lighten-3"
            :label="$t('input_data')"
            :placeholder="$t('input_data')"
            v-model="form.size"
          />
          <!-- <p>
            คุณสามารถเพิ่มแผงทีละหลายๆรายการที่มีพื้นที่ขนาดเท่ากันได้โดยใช้เครื่องหมาย
            Comma (,) คั่นตรงชื่อ/รหัสแผง
          </p> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="isLoading"
            color="error"
            elevation="0"
            @click.native="addMarketDialog = false"
            >{{ $t('cancel') }}</v-btn
          >
          <v-btn
            :loading="isLoading"
            color="primary"
            elevation="0"
            @click="createArea"
            :disabled="!form.name || !form.size ? true : false"
            >{{ $t('add_data') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="isError" color="error">
      {{ $t('validate.error_add_market_area') }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "AddArea",
  created() {},
  computed: {
    areaDialog() {
      this.form = {
        name: "",
        size: "",
      };
      return this.addMarketDialog;
    },
    ...mapGetters({
      getMarketName: "markets/getMarketName",
      getMarketId: "markets/getMarketId",
    }),
  },
  data() {
    return {
      marketId: "",
      addMarketDialog: false,
      isError: false,
      isLoading: false,
      form: {
        name: "",
        size: "",
      },
    };
  },
  props: {},
  methods: {
    loadMarket() {},
    createArea() {
      this.isLoading = true;
      this.$store
        .dispatch("area/createArea", {
          name: this.form.name,
          size: this.form.size,
          marketId: this.getMarketId,
        })
        .then(() => {
          (this.form = {
            name: "",
            size: "",
          }),
            (this.isLoading = false);
          this.addMarketDialog = false;
        })
        .catch((err) => {
          this.isError = true;
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
